import { Component, ElementRef } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { LearnspaceListBaseComponent } from '@shared/base-components/learnspace-list.base.component';
import { ProgramTemplatePickerDialogComponent } from '../program-template-picker/program-template-picker-dialog.component';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'program-list',
  templateUrl: './program-list.component.html',
  styleUrls: ['./program-list.component.scss'],
  animations: fuseAnimations
})

export class ProgramListComponent extends LearnspaceListBaseComponent {
  constructor(
    _courseApiService: CoursesAPIService,
    _dialog: MatDialog,
    _router: Router,
    _elRef: ElementRef,
    _currentHub: CurrentHubService
  ) {
    super(_courseApiService, _dialog, _router, _elRef, _currentHub);
    this._defaultListingMode = 'allPrivate';
  }

  addLearnspace(): void {
    this._dialog.open(ProgramTemplatePickerDialogComponent, {
      backdropClass: 'click-through-dialog-backdrop',
      panelClass: 'fullscreen-dialog',
      data: { hubId: this.hub.id, mode: this.hub.mode }
    })
      .afterClosed()
      .pipe(
        filter(a => a),
        map(ls => this._router.navigate([this.hub.urlTitle, ls.id]))
      ).subscribe();
  }
}
